import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/frontend/utils';
interface JavaScriptLogoProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}
export const JavaScriptLogo: React.FC<JavaScriptLogoProps> = t0 => {
  const $ = _c(22);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== t0) {
    const {
      size: t9,
      width,
      height,
      ...t10
    } = t0;
    props = t10;
    const size = t9 === undefined ? 16 : t9;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 256 256";
    t5 = "true";
    t6 = "img";
    t7 = "JavaScript logo";
    t8 = cn(props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <path fill="#dddddd" d="M0 0h256v256H0z" />;
    t10 = <path d="m67.312 213.932 19.59-11.856c3.78 6.701 7.218 12.371 15.465 12.371 7.905 0 12.89-3.092 12.89-15.12v-81.798h24.057v82.138c0 24.917-14.606 36.259-35.916 36.259-19.245 0-30.416-9.967-36.087-21.996m85.07-2.576 19.588-11.341c5.157 8.421 11.859 14.607 23.715 14.607 9.969 0 16.325-4.984 16.325-11.858 0-8.248-6.53-11.17-17.528-15.98l-6.013-2.58c-17.357-7.387-28.87-16.667-28.87-36.257 0-18.044 13.747-31.792 35.228-31.792 15.294 0 26.292 5.328 34.196 19.247l-18.732 12.03c-4.125-7.389-8.591-10.31-15.465-10.31-7.046 0-11.514 4.468-11.514 10.31 0 7.217 4.468 10.14 14.778 14.608l6.014 2.577c20.45 8.765 31.963 17.7 31.963 37.804 0 21.654-17.012 33.51-39.867 33.51-22.339 0-36.774-10.654-43.819-24.574" />;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t11 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} aria-hidden={t5} role={t6} aria-label={t7} className={t8} {...props}>{t9}{t10}</svg>;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};